import { toPlatePlugin } from '@udecode/plate/react';

import { BaseIndentPlugin } from '../lib/BaseIndentPlugin';

export const IndentPlugin = toPlatePlugin(BaseIndentPlugin);
